import { styled, TableRow, TableCell } from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

export const StyledTableRow = styled(TableRow)(() => ({
  transition: "transform 0.3s ease", // Añadir transición para suavizar el efecto de transformación
  "&:hover": {
    transform: "scale(1.01)", // Aumentar ligeramente el tamaño al hacer hover
  },
  "&:nth-of-type(odd)": {
    backgroundColor: "#FFFFFF", // Fondo para filas impares
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#EEF3F6", // Fondo para filas pares
    "& > td:first-of-type": {
      borderTopLeftRadius: "20px",
      borderBottomLeftRadius: "20px",
    },
    "& > td:last-of-type": {
      borderTopRightRadius: "20px",
      borderBottomRightRadius: "20px",
    },
  },
}));

export const StyledTableCell = styled(TableCell)(({ align = "left" }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#336B87",
    color: "#FFF",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: "1rem",
    padding: "16px 24px",
    border: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "0.9rem",
    fontFamily: "Montserrat",
    color: "#336B87",
    borderBottom: "none", // Sin bordes para cuerpo
    padding: "16px 24px",
    border: "none",
  },
  borderBottom: "none",
  "&:first-of-type": {
    borderTopLeftRadius: "10px", // Bordes redondeados en la primera celda de la fila
    borderBottomLeftRadius: "10px",
  },
  "&:last-of-type": {
    borderTopRightRadius: "10px", // Bordes redondeados en la última celda de la fila
    borderBottomRightRadius: "10px",
  },
}));
